
/**
 * Build a flat list of all togglable service ids from the config
 * @param {*} categoryConfig 
 * @returns 
 */
export const getAllServiceIds = (categoryConfig) =>
  categoryConfig.flatMap(cat => cat.services.map(s => s.id))

/**
 * Build the initial { [serviceId]: boolean } state, all false
 * @param {*} categoryConfig 
 * @returns 
 */
export const getInitialServicesState = (categoryConfig) =>
  Object.fromEntries(getAllServiceIds(categoryConfig).map(id => [id, false]))

// From a saved consent array (legacy tags), derive per-service booleans
export const servicesFromConsent = (categoryConfig, consentObject = {}) => {
  const result = {};
  categoryConfig.forEach(cat => {
    if (!cat.services) return;

    cat.services.forEach(service => {
      result[service.id] = consentObject[service.id] ?? false;
    });
  });

  return result;
};

/**
 * check if the main checkbox is checked
 * @param {*} cat 
 * @param {*} services 
 * @returns 
 */
export const isCategoryChecked = (cat, services) =>
  cat.services.length === 0 ? true : cat.services.every(s => services[s.id])

/**
 * Toggle every service in a category to the same (opposite) value
 * @param {*} cat 
 * @param {*} services 
 * @returns 
 */
export const toggleCategory = (cat, services) => {
  const next = !isCategoryChecked(cat, services)
  const update = {}
  cat.services.forEach(service => { update[service.id] = next })
  return { ...services, ...update }
}

/**
 *  Set every service to the same boolean value (for accept all / refuse all)
 * @param {*} categoryConfig 
 * @param {*} value 
 * @returns 
 */
export const setAllServices = (categoryConfig, value) =>
  Object.fromEntries(getAllServiceIds(categoryConfig).map(id => [id, value]))